import dynamic from 'next/dynamic';
import type { FC } from 'react';

import { Tab } from '@/core/tamagoshi/Tab/Tab';
import { TabItem } from '@/core/tamagoshi/Tab/TabItem';
import { AllReviews } from '@/domains/productDiscovery/ArticleReviews/modules/allReviews/AllReviews';
import { DescriptionBlock } from '@/domains/productDiscovery/ProductPage/b2c/components/DescriptionBlock/DescriptionBlock';
import { ProductInformations } from '@/domains/productDiscovery/ProductPage/b2c/modules/TabsContainer/components/ProductInformation/ProductInformations';
import { TabModalProps } from '@/domains/productDiscovery/ProductPage/components/TabModal/TabModal';
import {
  reviewsTab,
  useTabs,
} from '@/domains/productDiscovery/ProductPage/hooks/useTabs';

import {
  tabsContainerBackBtn,
  tabsContainerDetails,
  tabsContainerInformations,
  tabsContainerReviews,
} from './translations';

import styles from './tabsContainer.module.scss';

const TabModal = dynamic<TabModalProps>(
  () =>
    import(
      '@/domains/productDiscovery/ProductPage/components/TabModal/TabModal'
    ).then((mod) => mod.TabModal),
  { ssr: false },
);

export const TabsContainer: FC = () => {
  const {
    tabs,
    hash,
    shouldHideTabs,
    isTabsContainerDisplayed,
    closeTabsContainer,
    goToDescription,
    goToReviews,
  } = useTabs();

  if (!isTabsContainerDisplayed) return null;
  return (
    <TabModal
      title={tabsContainerInformations}
      backButtonText={tabsContainerBackBtn}
      onClose={closeTabsContainer}
    >
      {!shouldHideTabs && (
        <Tab className={styles.tabs} value={hash}>
          {tabs.description.display && (
            <TabItem onClick={goToDescription} value={tabs.description.hash}>
              {tabsContainerDetails}
            </TabItem>
          )}
          {tabs.reviews.display && (
            <TabItem
              onClick={() => goToReviews('all')}
              value={tabs.reviews.hash}
            >
              {tabsContainerReviews}
            </TabItem>
          )}
        </Tab>
      )}
      <div className={styles.tabContent}>
        <ProductInformations />
        {(() => {
          switch (hash) {
            case tabs.description.hash:
              return <DescriptionBlock isTab />;
            case reviewsTab.mainHash:
              return <AllReviews />;

            default:
              return <DescriptionBlock isTab />;
          }
        })()}
      </div>
    </TabModal>
  );
};
